module.exports = __webpack_public_path__ + "img/Wolfgang-Hardle-4x.7f4d6db4.png";